import { fabric } from "fabric";
import FontFaceObserver from "fontfaceobserver";
import { parseRGBA } from "@/mixins/utils";
import { v4 as uuidv4 } from "uuid";

fabric.Canvas.prototype.getItemsByMyType = function (name) {
  let objectList = [],
    objects = this.getObjects();

  for (let i = 0, len = this.size(); i < len; i++) {
    if (objects[i].myType && objects[i].myType === name) {
      objectList.push(objects[i]);
    }
  }

  return objectList;
}

function changeBackgroundImageFilter(template, inc) {
  fabric.textureSize = 8192; // da ne cropa slik pri filtru

  // replace filter
  let ind = -1;
  ind = template.canvas.backgroundImage.filters.findIndex(
    x => x.fName == "classicFilter"
  );

  if (ind > -1) template.canvas.backgroundImage.filters.splice(ind, 1);

  //let filterStr = "";  

  if (template.canvas.backgroundImageFilter == 1) {
    template.canvas.backgroundImage.filters.push(
      new fabric.Image.filters.Grayscale({ fName: "classicFilter" })
    );
    //filterStr = this.$t("fabricImageFilterGrayscale");
  } else if (template.canvas.backgroundImageFilter == 2) {
    template.canvas.backgroundImage.filters.push(
      new fabric.Image.filters.Vintage({ fName: "classicFilter" })
    );
    //filterStr = this.$t("fabricImageFilterVintage");
  } else if (template.canvas.backgroundImageFilter == 3) {
    template.canvas.backgroundImage.filters.push(
      new fabric.Image.filters.Brownie({ fName: "classicFilter" })
    );

    //filterStr = this.$t("fabricImageFilterBrownie");
  } else if (template.canvas.backgroundImageFilter == 4) {
    template.canvas.backgroundImage.filters.push(
      new fabric.Image.filters.Sepia({ fName: "classicFilter" })
    );
    //filterStr = this.$t("fabricImageFilterSephia");
  } else if (template.canvas.backgroundImageFilter == 5) {
    template.canvas.backgroundImage.filters.push(
      new fabric.Image.filters.Kodachrome({ fName: "classicFilter" })
    );
    //filterStr = this.$t("fabricImageFilterKodachrome");
  } else {
    //filterStr = this.$t("fabricImageFilterNoFilter");
  }

  /*this.$store.commit({
    type: "showSnackbar",
    color: "accent",
    message: this.$t("fabricImageFilterBase") + ": " + filterStr
  });*/

  if (inc) {
    if (template.canvas.backgroundImageFilter >= 5) {
      template.canvas.backgroundImageFilter = 1;
    } else template.canvas.backgroundImageFilter++;
  }

  template.canvas.backgroundImage.applyFilters();
  template.canvas.requestRenderAll();
}

function changeBackgroundImageBlur(template) {
  fabric.textureSize = 8192; // da ne cropa slik pri filtru

  // replace filter
  let ind = -1;
  ind = template.canvas.backgroundImage.filters.findIndex(
    x => x.fName == "blurFilter"
  );

  if (ind > -1) template.canvas.backgroundImage.filters.splice(ind, 1);

  template.canvas.backgroundImage.filters.push(
    new fabric.Image.filters.Blur({
      blur: template.canvas.backgroundImageBlur,
      fName: "blurFilter"
    })
  );
  template.canvas.backgroundImage.applyFilters();
  template.canvas.requestRenderAll();
}

function changeBackgroundImageBrightness(template) {
  fabric.textureSize = 8192; // da ne cropa slik pri filtru

  // replace filter
  let ind = -1;
  ind = template.canvas.backgroundImage.filters.findIndex(
    x => x.fName == "brightnessFilter"
  );

  if (ind > -1) template.canvas.backgroundImage.filters.splice(ind, 1);

  template.canvas.backgroundImage.filters.push(
    new fabric.Image.filters.Brightness({
      brightness: template.canvas.backgroundImageBrightness,
      fName: "brightnessFilter"
    })
  );
  template.canvas.backgroundImage.applyFilters();
  template.canvas.requestRenderAll();
}

function changeBackgroundImageContrast(template) {
  fabric.textureSize = 8192; // da ne cropa slik pri filtru

  // replace filter
  let ind = -1;
  ind = template.canvas.backgroundImage.filters.findIndex(
    x => x.fName == "contrastFilter"
  );

  if (ind > -1) template.canvas.backgroundImage.filters.splice(ind, 1);

  template.canvas.backgroundImage.filters.push(
    new fabric.Image.filters.Contrast({
      contrast: template.canvas.backgroundImageContrast,
      fName: "contrastFilter"
    })
  );
  template.canvas.backgroundImage.applyFilters();
  template.canvas.requestRenderAll();
}

function addTemplateText(template, dimensions, rulesText, fonts, textBrushes, textBrush, defaultText, myBreakpoint, active, mode) {
  // eslint-disable-next-line
  return new Promise((resolve, reject) => {

    //console.log(template, dimensions, rulesText, fonts);
    /**
         *
         * fabric.Textbox.prototype._renderText
         *
         * Extended to reverse order of stroke and filling, to allow for more pleasing
         * stroke.
         *
         * @see    http://stackoverflow.com/questions/26639132/canvas-fabricjs-separate-stroke-from-text-edge
         * @access private
         * @return void
         */
    fabric.IText.prototype._renderText = function (ctx) {
      //this._translateForTextAlign(ctx);
      this._renderTextFill(ctx);
      this._renderTextStroke(ctx);
      this._renderTextFill(ctx);
      //this._translateForTextAlign(ctx, true);
    };

    // nisem čist siguren a pomaga tole za padding ali ne..
    // Change the padding logic to include background-color
    fabric.IText.prototype.set({
      _getNonTransformedDimensions() {
        // Object dimensions
        return new fabric.Point(this.width, this.height).scalarAdd(100);
      },
      _calculateCurrentDimensions() {
        // Controls dimensions
        return fabric.util.transformPoint(
          this._getTransformedDimensions(),
          this.getViewportTransform(),
          true
        );
      }
    });

    // najprej naložimo vse fonte, potem ustvarimo besedilo
    let observers = [];
    // Make one observer for each font,
    // by iterating over the data we already have
    fonts.forEach(x => {
      observers.push(new FontFaceObserver(x).load());
    });

    fabric.util.clearFabricFontCache();

    Promise.all(observers)
      .then(() => {
        let iText4 = new fabric.IText(defaultText, {
          myType: "text",
          textFunction: "textFunction" in rulesText ? rulesText.textFunction : 0,
          allowDelete: "allowDelete" in rulesText ? rulesText.allowDelete : false,
          allowManipulate: "allowManipulate" in rulesText ? rulesText.allowManipulate : false,
          allowEdit: "allowEdit" in rulesText ? rulesText.allowEdit : false,
          left: !active ? rulesText.left : dimensions.width / 2,
          top: !active ? rulesText.top : dimensions.height / 2,
          angle: !active ? rulesText.angle : 0,
          fontSize: !active ? rulesText.fontSize : dimensions.width / 15,
          fontFamily: !active ? fonts[rulesText.fontText] : fonts[textBrushes[7].fontText],
          scaleX: !active ? rulesText.scaleX : 1,
          scaleY: !active ? rulesText.scaleY : 1,
          textAlign: "center",
          originX: "center",
          originY: "center",
          selectable: (("allowDelete" in rulesText && rulesText.allowDelete) || ("allowManipulate" in rulesText && rulesText.allowManipulate) || ("allowEdit" in rulesText && rulesText.allowEdit)) || mode ? true : false,
          evented: (("allowDelete" in rulesText && rulesText.allowDelete) || ("allowManipulate" in rulesText && rulesText.allowManipulate) || ("allowEdit" in rulesText && rulesText.allowEdit)) || mode ? true : false,
          lockMovementX: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? false : true,
          lockMovementY: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? false : true,
          editable: ("allowEdit" in rulesText && rulesText.allowEdit) || mode ? true : false,
          stroke: !active ? rulesText.shadowTextColor : textBrushes[7].shadowTextColor,
          strokeWidth: !active ? rulesText.shadowText : textBrushes[7].shadowText,
          fill: !active ? rulesText.textColor : parseRGBA(textBrushes[7].textColor),
          backgroundColor: !active ? rulesText.textColorBackground : parseRGBA(textBrushes[7].textColorBackground),
          caching: false
          //padding: this.canvasTemplates[index].selected.width / 10
        });

        iText4.setControlsVisibility({
          tl: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? true : false,
          tr: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? true : false,
          bl: ("allowManipulate" in rulesText && rulesText.allowManipulate) || ("allowDelete" in rulesText && rulesText.allowDelete) || mode ? true : false,
          br: ("allowManipulate" in rulesText && rulesText.allowManipulate) || ("allowEdit" in rulesText && rulesText.allowEdit) || mode ? true : false,
          ml: false,
          mt: false,
          mr: false,
          mb: false,
          mtr: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? true : false,
        });

        iText4.set({
          centeredScaling: true,
          rotatingPointOffset: dimensions.width / 20,
          borderColor: "rgba(255,0,0,0.5)",
          cornerSize: myBreakpoint.smAndUp
            ? dimensions.width / 25
            : dimensions.width / 12,
          cornerShape: "rect",
          cornerStrokeColor: "rgba(0,0,0,0)",
          borderScaleFactor: dimensions.width / 150,
          transparentCorners: true
          //cornerBackgroundColor: "black",
        });

        iText4.customiseCornerIcons({
          tl: {
            icon: require("@/assets/resize-icon-tl.svg")
          },
          tr: {
            icon: require("@/assets/resize-icon-tr.svg")
          },
          bl: {
            icon: ("allowDelete" in rulesText && rulesText.allowDelete) || mode ? require("@/assets/delete-icon.svg") : require("@/assets/resize-icon-bl.svg")
          },
          br: {
            icon: ("allowEdit" in rulesText && rulesText.allowEdit) || mode ? require("@/assets/edit-icon.svg") : require("@/assets/resize-icon-br.svg")
          },
          mtr: {
            icon: require("@/assets/rotate-icon.svg")
          }
        });

        iText4.on("deselected", function () {
          iText4.exitEditing();
          template.canvas.showTextControls = false;
          console.log("text deselected => exitEditing/hideControls", template.canvas.showTextControls);
          //this.canvasTemplates[index].canvas.bringToFront(e);
        });

        iText4.on("selected", function () {
          (("allowEdit" in rulesText && rulesText.allowEdit) || mode) ? template.canvas.showTextControls = true : template.canvas.showTextControls = false;

          fabric.Canvas.prototype.customiseControls({
            bl: {
              action: ("allowDelete" in rulesText && rulesText.allowDelete) || mode ? "remove" : "scale",
              cursor: ("allowDelete" in rulesText && rulesText.allowDelete) || mode ? "pointer" : "resize"
            },
            br: {
              cursor: ("allowEdit" in rulesText && rulesText.allowEdit) ? "pointer" : "resize",
              action: ("allowEdit" in rulesText && rulesText.allowEdit) ? function (e, target) {
                target.enterEditing();
                target.selectAll();
              } : "scale",
            }
          });

          console.log(textBrush);
          //e.bringToFront();
          //vm.canvasTemplates[index].canvas.setActiveObject(e);
          console.log("text selected => showCOntrols", template.canvas.showTextControls);
        });

        if (active) {
          // Render in canvas in propper layer order position
          let c = 0;
          let found = false;
          template.canvas.forEachObject(x => {
            if (
              x.myType != "freeDrawing"
            ) {
              c++;
            } else found = true;
          });

          if (found) {
            template.canvas
              .insertAt(iText4, c)
              .setActiveObject(iText4);
          } else
            template.canvas
              .add(iText4)
              .setActiveObject(iText4);

          iText4.enterEditing();
          iText4.selectAll();
          resolve(template.canvas.requestRenderAll());
        } else {
          if (mode) {
            resolve(template.canvas.add(iText4).requestRenderAll());
          } else {
            template.canvas.add(iText4);
            setTimeout(function () {
              resolve(template.canvas.requestRenderAll());
            }, 250);
          }
        }
        console.log("==> TEMPLATE TEXT ADDED.");
      })
      .catch(function (e) {
        console.log(e);
      });
  });
}

function addText(template, dimensions, rulesText, fonts, textBrushes, textBrush, defaultText, myBreakpoint, active, mode, canvasMF, subType) {
  // eslint-disable-next-line
  return new Promise((resolve, reject) => {

    //console.log(template, dimensions, rulesText, fonts);
    /**
         *
         * fabric.Textbox.prototype._renderText
         *
         * Extended to reverse order of stroke and filling, to allow for more pleasing
         * stroke.
         *
         * @see    http://stackoverflow.com/questions/26639132/canvas-fabricjs-separate-stroke-from-text-edge
         * @access private
         * @return void
         */
    fabric.IText.prototype._renderText = function (ctx) {
      //this._translateForTextAlign(ctx);
      this._renderTextFill(ctx);
      this._renderTextStroke(ctx);
      this._renderTextFill(ctx);
      //this._translateForTextAlign(ctx, true);
    };

    // nisem čist siguren a pomaga tole za padding ali ne..
    // Change the padding logic to include background-color
    fabric.IText.prototype.set({
      _getNonTransformedDimensions() {
        // Object dimensions
        return new fabric.Point(this.width, this.height).scalarAdd(100 * canvasMF);
      },
      _calculateCurrentDimensions() {
        // Controls dimensions
        return fabric.util.transformPoint(
          this._getTransformedDimensions(),
          this.getViewportTransform(),
          true
        );
      }
    });

    // najprej naložimo vse fonte, potem ustvarimo besedilo
    let observers = [];
    // Make one observer for each font,
    // by iterating over the data we already have
    fonts.forEach(x => {
      observers.push(new FontFaceObserver(x).load());
    });

    fabric.util.clearFabricFontCache();

    Promise.all(observers)
      .then(() => {
        let iText4 = new fabric.IText(defaultText, {
          myType: "text",
          mySubType: subType,
          myTextFunction: subType == "giftCard" ? rulesText.textFunction : "",
          textFunction: "textFunction" in rulesText ? rulesText.textFunction : 0,
          allowDelete: "allowDelete" in rulesText ? rulesText.allowDelete : false,
          allowManipulate: "allowManipulate" in rulesText ? rulesText.allowManipulate : false,
          allowEdit: "allowEdit" in rulesText ? rulesText.allowEdit : false,
          left: !active ? rulesText.left * canvasMF : (dimensions.width / 2) * canvasMF,
          top: !active ? rulesText.top * canvasMF : (dimensions.height / 2) * canvasMF,
          angle: !active ? rulesText.angle : 0,
          fontSize: !active ? rulesText.fontSize * canvasMF : (dimensions.width / 15) * canvasMF,
          fontFamily: !active ? fonts[rulesText.fontText] : fonts[textBrushes[7].fontText],
          scaleX: !active ? rulesText.scaleX : 1,
          scaleY: !active ? rulesText.scaleY : 1,
          textAlign: "center",
          originX: "center",
          originY: "center",
          selectable: (("allowDelete" in rulesText && rulesText.allowDelete) || ("allowManipulate" in rulesText && rulesText.allowManipulate) || ("allowEdit" in rulesText && rulesText.allowEdit)) || mode ? true : false,
          evented: (("allowDelete" in rulesText && rulesText.allowDelete) || ("allowManipulate" in rulesText && rulesText.allowManipulate) || ("allowEdit" in rulesText && rulesText.allowEdit)) || mode ? true : false,
          lockMovementX: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? false : true,
          lockMovementY: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? false : true,
          editable: ("allowEdit" in rulesText && rulesText.allowEdit) || mode ? true : false,
          stroke: !active ? rulesText.shadowTextColor : textBrushes[7].shadowTextColor,
          strokeWidth: !active ? rulesText.shadowText * canvasMF : textBrushes[7].shadowText * canvasMF,
          fill: !active ? rulesText.textColor : parseRGBA(textBrushes[7].textColor),
          backgroundColor: !active ? rulesText.textColorBackground : parseRGBA(textBrushes[7].textColorBackground),
          caching: false
          //padding: this.canvasTemplates[index].selected.width / 10
        });

        iText4.setControlsVisibility({
          tl: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? true : false,
          tr: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? true : false,
          bl: ("allowManipulate" in rulesText && rulesText.allowManipulate) || ("allowDelete" in rulesText && rulesText.allowDelete) || mode ? true : false,
          br: ("allowManipulate" in rulesText && rulesText.allowManipulate) || ("allowEdit" in rulesText && rulesText.allowEdit) || mode ? true : false,
          ml: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? true : false,
          mt: false,
          mr: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? true : false,
          mb: false,
          mtr: ("allowManipulate" in rulesText && rulesText.allowManipulate) || mode ? true : false,
        });

        iText4.set({
          centeredScaling: true,
          rotatingPointOffset: dimensions.width / 20 * canvasMF,
          borderColor: "rgba(255,0,0,0.5)",
          cornerSize: myBreakpoint.smAndUp
            ? dimensions.width / 25 * canvasMF
            : dimensions.width / 12 * canvasMF,
          cornerShape: "rect",
          cornerStrokeColor: "rgba(0,0,0,0)",
          borderScaleFactor: dimensions.width / 150 * canvasMF,
          transparentCorners: true
          //cornerBackgroundColor: "black",
        });

        iText4.customiseCornerIcons({
          tl: {
            icon: require("@/assets/resize-icon-tl.svg")
          },
          tr: {
            icon: require("@/assets/resize-icon-tr.svg")
          },
          bl: {
            icon: ("allowDelete" in rulesText && rulesText.allowDelete) || mode ? require("@/assets/delete-icon.svg") : require("@/assets/resize-icon-bl.svg")
          },
          br: {
            icon: ("allowEdit" in rulesText && rulesText.allowEdit) || mode ? require("@/assets/edit-icon.svg") : require("@/assets/resize-icon-br.svg")
          },
          ml: {
            icon: require("@/assets/down-arrow.svg")
          },
          mr: {
            icon: require("@/assets/up-arrow.svg")
          },
          mtr: {
            icon: require("@/assets/rotate-icon.svg")
          }
        });

        iText4.on("deselected", function () {
          iText4.exitEditing();
          template.canvas.showTextControls = false;
          console.log("text deselected => exitEditing/hideControls", template.canvas.showTextControls);
          //this.canvasTemplates[index].canvas.bringToFront(e);
        });

        iText4.on("selected", function () {
          (("allowEdit" in rulesText && rulesText.allowEdit) || mode) ? template.canvas.showTextControls = true : template.canvas.showTextControls = false;

          fabric.Canvas.prototype.customiseControls({
            bl: {
              action: ("allowDelete" in rulesText && rulesText.allowDelete) || mode ? "remove" : "scale",
              cursor: ("allowDelete" in rulesText && rulesText.allowDelete) || mode ? "pointer" : "resize"
            },
            br: {
              cursor: ("allowEdit" in rulesText && rulesText.allowEdit) ? "pointer" : "resize",
              action: ("allowEdit" in rulesText && rulesText.allowEdit) ? function (e, target) {
                target.enterEditing();
                target.selectAll();
              } : "scale",
            },
            ml: {
              cursor: "pointer",
              action: function (e, target) {
                target.sendBackwards(true);
              },
            },
            mr: {
              cursor: "pointer",
              action: function (e, target) {
                target.bringForward(true);
              },
            },
          });

          console.log(textBrush);
          //e.bringToFront();
          //vm.canvasTemplates[index].canvas.setActiveObject(e);
          console.log("text selected => showCOntrols", template.canvas.showTextControls);
        });

        if (active) {
          // Render in canvas in propper layer order position
          let c = 0;
          let found = false;
          template.canvas.forEachObject(x => {
            if (
              x.myType != "freeDrawing"
            ) {
              c++;
            } else found = true;
          });

          if (found) {
            template.canvas
              .insertAt(iText4, c)
              .setActiveObject(iText4);
          } else
            template.canvas
              .add(iText4)
              .setActiveObject(iText4);

          iText4.enterEditing();
          iText4.selectAll();
          resolve(template.canvas.requestRenderAll());
        } else {
          if (mode) {
            resolve(template.canvas.add(iText4).requestRenderAll());
          } else {
            template.canvas.add(iText4);
            setTimeout(function () {
              resolve(template.canvas.requestRenderAll());
            }, 250);
          }
        }
        console.log("==> TEXT ADDED.");
      })
      .catch(function (e) {
        console.log(e);
      });
  });
}

function addTemplateFrame(item, currentItem, canvasTemplate, mode, myBreakpoint, setActive, rotated) {
  console.log("addTemplateFrame", item, currentItem, canvasTemplate, mode, myBreakpoint, setActive, rotated);
  // eslint-disable-next-line
  return new Promise((resolve, reject) => {
    fabric.Image.fromURL(
      item.image,
      function (img) {
        let img1 = img.set({
          width: item.width,
          height: item.height,
          selectable: false,
          evented: false,
        });

        let rectangle = new fabric.Rect({
          clipP: item.coordinates.mode,
          width: Number(item.coordinates.width),
          height: Number(item.coordinates.height),
          top: Number(item.coordinates.top),
          left: Number(item.coordinates.left),
          angle: Number(item.coordinates.angle),
          originX: "center",
          originY: "center",
          fill: "rgba(100,200,200,0.35)",
          stroke: "red",
          strokeWidth: 1,
          selectable: false,
          evented: false,
        });

        if (item.coordinates.mode == "circle") {
          rectangle.clipPath = new fabric.Ellipse({
            top: -Number(item.coordinates.height) / 2,
            left: -Number(item.coordinates.width) / 2,
            rx: Number(item.coordinates.width) / 2,
            ry: Number(item.coordinates.height) / 2
          });
        }

        let group1 = new fabric.Group([rectangle, img1], {
          id: item.id,
          image: item.image,
          myType: "templateFrame",
          myWidth: item.width,
          myHeight: item.height,
          myRotated: rotated,
          myRotate: item.rotate,
          coordinates: item.coordinates,
          left: item.left ? item.left : currentItem.width / 2,
          top: item.top ? item.top : currentItem.height / 2,
          angle: item.angle ? item.angle : 0,
          scaleX: item.scaleX
            ? item.scaleX
            : item.width > currentItem.width
              ? 0.5
              : item.width * 2.5 < currentItem.width
                ? 2
                : 1,
          scaleY: item.scaleX
            ? item.scaleX
            : item.width > currentItem.width
              ? 0.5
              : item.width * 2.5 < currentItem.width
                ? 2
                : 1,
          originX: "center",
          originY: "center",
          selectable: mode,
          evented: mode,
          centeredScaling: true,
          borderColor: "rgba(255,0,0,0.5)",
          cornerStrokeColor: "rgba(0,0,0,0)",
          borderScaleFactor: currentItem.width / 150,
          rotatingPointOffset: currentItem.width / 20,
          cornerSize: myBreakpoint.smAndUp
            ? currentItem.width / 25
            : currentItem.width / 12,
          cornerShape: "rect",
          transparentCorners: true
        });

        if (item.rotate) {
          group1.setControlsVisibility({
            tl: true,
            tr: true,
            bl: true,
            br: true,
            ml: false,
            mt: false,
            mr: true,
            mb: false,
            mtr: true
          });
        } else {
          group1.setControlsVisibility({
            tl: true,
            tr: true,
            bl: true,
            br: true,
            ml: false,
            mt: false,
            mr: false,
            mb: false,
            mtr: true
          });
        }

        if (rotated) {
          console.log("IS ROTATED", rotated);
          group1.customiseCornerIcons({
            tl: {
              icon: require("@/assets/resize-icon-tl.svg")
            },
            tr: {
              icon: require("@/assets/resize-icon-tr.svg")
            },
            bl: {
              icon: require("@/assets/delete-icon.svg")
            },
            br: {
              icon: require("@/assets/resize-icon-br.svg")
            },
            mr: {
              icon: require("@/assets/rotation-updated-icon.svg")
            },
            mtr: {
              icon: require("@/assets/rotate-icon.svg")
            }
          });
        } else {
          group1.customiseCornerIcons({
            tl: {
              icon: require("@/assets/resize-icon-tl.svg")
            },
            tr: {
              icon: require("@/assets/resize-icon-tr.svg")
            },
            bl: {
              icon: require("@/assets/delete-icon.svg")
            },
            br: {
              icon: require("@/assets/resize-icon-br.svg")
            },
            mr: {
              icon: require("@/assets/rotation-icon.svg")
            },
            mtr: {
              icon: require("@/assets/rotate-icon.svg")
            }
          });
        }

        group1.on("selected", function () {
          fabric.Canvas.prototype.customiseControls({
            bl: {
              action: "remove",
              cursor: "pointer"
            },
            br: {
              cursor: "resize",
              action: "scale"
            },
            tl: {
              cursor: "resize",
              action: "scale"
            },
            mr: {
              cursor: "pointer",
              action: function (e, target) {
                console.log(target.myRotated);
                target.set({
                  myRotated: !target.myRotated
                });
                if (target.myRotated) {
                  console.log("ACTION TRUE");
                  target.customiseCornerIcons({
                    mr: {
                      icon: require("@/assets/rotation-updated-icon.svg")
                    }
                  });
                } else {
                  console.log("ACTION FALSE");
                  target.customiseCornerIcons({
                    mr: {
                      icon: require("@/assets/rotation-icon.svg")
                    }
                  });
                }
                canvasTemplate.canvas.requestRenderAll();
                console.log(target.myRotated);
              }
            }
          });
        });

        if (setActive) {
          // Render in canvas in propper layer order position
          let c = 0;
          canvasTemplate.canvas.forEachObject(x => {
            if (
              x.myType != "frame" &&
              x.myType != "templateFrame" &&
              x.myType != "templateFramePlaceholder" &&
              x.myType != "collageGroup" &&
              x.myType != "simpleImage" &&
              x.myType != "sticker" &&
              x.myType != "text" &&
              x.myType != "freeDrawing"
            )
              c++;
          });

          resolve(
            canvasTemplate.canvas
              .insertAt(group1, c <= 0 ? 0 : c - 1)
              .requestRenderAll()
          );
        } else {
          resolve(canvasTemplate.canvas.add(group1).requestRenderAll());
        }

        console.log("==> FRAME ADDED.");
      },
      { crossOrigin: "*" }
    );
  });
}

function addFrame(item, currentItem, canvasTemplate, myBreakpoint, cIndex, iIndex, canvasMF) {
  console.log("addFrame", cIndex, iIndex);
  // eslint-disable-next-line
  return new Promise((resolve, reject) => {
    fabric.Image.fromURL(
      item.image,
      function (img) {
        let img1 = img.set({
          width: item.width,
          height: item.height,
          selectable: false,
          evented: false,
        });

        let rectangle = new fabric.Rect({
          fill: "silver",
          width: Number(item.coordinates.width),
          height: Number(item.coordinates.height),
          top: Number(item.coordinates.top),
          left: Number(item.coordinates.left),
          angle: Number(item.coordinates.angle),
          originX: "center",
          originY: "center",
          clipP: item.coordinates.mode,
          lockMovementX: true,
          lockMovementY: true,
          selectable: false
        });

        let group1 = new fabric.Group([rectangle, img1], {
          myType: "templateFramePlaceholder",
          cIndex: cIndex,
          iIndex: iIndex,
          left: Number(item.left) * canvasMF,
          top: Number(item.top) * canvasMF,
          angle: Number(item.angle),
          scaleX: item.scaleX ? item.scaleX * canvasMF : 1 * canvasMF,
          scaleY: item.scaleX ? item.scaleX * canvasMF : 1 * canvasMF,
          lockMovementX: true,
          lockMovementY: true,
          originX: "center",
          originY: "center",
          selectable: true,
          centeredScaling: true,
          borderColor: "rgba(255,0,0,0.5)",
          cornerStrokeColor: "rgba(0,0,0,0)",
          borderScaleFactor: currentItem.width / 150 * canvasMF,
          rotatingPointOffset: 0,
          cornerSize: myBreakpoint.smAndUp
            ? currentItem.width / 25 * canvasMF
            : currentItem.width / 12 * canvasMF,
          cornerShape: "rect",
          transparentCorners: true
        });

        fabric.Image.fromURL(
          require("@/assets/add-image.png"),
          function (img) {
            let img2 = img.set({
              left: Number(item.left) * canvasMF,
              top: Number(item.top) * canvasMF,
              width: Number(item.width),
              height: Number(item.width),
              angle: item.rotated ? item.angle + 90 : item.angle,
              lockMovementX: true,
              lockMovementY: true,
              originX: "center",
              originY: "center",
              selectable: false
            });
            img2.scale(0.05);

            group1.setControlsVisibility({
              tl: false,
              tr: false,
              bl: false,
              br: false,
              ml: false,
              mt: false,
              mr: false,
              mb: false,
              mtr: false
            });

            group1.customiseCornerIcons({
              tl: {
                icon: require("@/assets/resize-icon-tl.svg")
              },
              tr: {
                icon: require("@/assets/resize-icon-tr.svg")
              },
              bl: {
                icon: require("@/assets/delete-icon.svg")
              },
              br: {
                icon: require("@/assets/resize-icon-br.svg")
              },
              mtr: {
                icon: require("@/assets/rotate-icon.svg")
              }
            });

            group1.on("selected", function () {
              //vm.cIndex = group2.cIndex;
              //vm.iIndex = group2.iIndex;
              //vm.cIndexMode = "addNewTemplateImage";              
              document
                .getElementById(
                  "canvas-0-input-frame-" + iIndex
                )
                .click();
            });

            group1.addWithUpdate(img2);

            if (item.coordinates.mode == "circle") {
              rectangle.clipPath = new fabric.Ellipse({
                top: -Number(item.coordinates.height) / 2,
                left: -Number(item.coordinates.width) / 2,
                rx: Number(item.coordinates.width) / 2,
                ry: Number(item.coordinates.height) / 2
              });
            }

            resolve(canvasTemplate.canvas.add(group1).requestRenderAll());
            console.log("TEMPLATE FRAME PLACEHOLDER IMAGE ADDED");
          },
          { crossOrigin: "anonymous" }
        );
      },
      { crossOrigin: "*" }
    );

    /*  
        let rectangle = new fabric.Rect({
          clipP: item.coordinates.mode,
          width: Number(item.coordinates.width),
          height: Number(item.coordinates.height),
          top: Number(item.coordinates.top),
          left: Number(item.coordinates.left),
          angle: Number(item.coordinates.angle),
          originX: "center",
          originY: "center",
          fill: "rgba(100,200,200,0.35)",
          stroke: "red",
          strokeWidth: 1,
          selectable: false,
          evented: false,
        });

        if (item.coordinates.mode == "circle") {
          rectangle.clipPath = new fabric.Ellipse({
            top: -Number(item.coordinates.height) / 2,
            left: -Number(item.coordinates.width) / 2,
            rx: Number(item.coordinates.width) / 2,
            ry: Number(item.coordinates.height) / 2
          });
        }      
*/
  });
}

function addTemplateSticker(item, currentItem, canvasTemplate, myBreakpoint, setActive) {
  // eslint-disable-next-line
  return new Promise((resolve, reject) => {
    fabric.Image.fromURL(
      item.image,
      function (img) {
        let img1 = img.set({
          id: item.id,
          image: item.image,
          myType: "sticker",
          allowDelete: "allowDelete" in item ? item.allowDelete : false,
          allowManipulate: "allowManipulate" in item ? item.allowManipulate : false,
          allowReplace: "allowReplace" in item ? item.allowReplace : "",
          left: item.left ? item.left : currentItem.width / 2,
          top: item.top ? item.top : currentItem.height / 2,
          angle: item.angle ? item.angle : 0,
          scaleX: item.scaleX
            ? item.scaleX
            : item.width > currentItem.width
              ? 0.5
              : item.width * 2.5 < currentItem.width
                ? 2
                : 1,
          scaleY: item.scaleX
            ? item.scaleX
            : item.width > currentItem.width
              ? 0.5
              : item.width * 2.5 < currentItem.width
                ? 2
                : 1,
          originX: "center",
          originY: "center",
          selectable: true,
          evented: true,
          centeredScaling: true,
          borderColor: "rgba(255,0,0,0.5)",
          cornerStrokeColor: "rgba(0,0,0,0)",
          borderScaleFactor: currentItem.width / 150,
          rotatingPointOffset: currentItem.width / 20,
          cornerSize: myBreakpoint.smAndUp
            ? currentItem.width / 25
            : currentItem.width / 12,
          cornerShape: "rect",
          transparentCorners: true
        });

        img1.setControlsVisibility({
          tl: true,
          tr: true,
          bl: true,
          br: true,
          ml: false,
          mt: false,
          mr: false,
          mb: false,
          mtr: true
        });

        img1.customiseCornerIcons({
          tl: {
            icon: require("@/assets/resize-icon-tl.svg")
          },
          tr: {
            icon: require("@/assets/resize-icon-tr.svg")
          },
          bl: {
            icon: require("@/assets/delete-icon.svg")
          },
          br: {
            icon: require("@/assets/resize-icon-br.svg")
          },
          mtr: {
            icon: require("@/assets/rotate-icon.svg")
          }
        });

        img1.on("selected", function () {
          fabric.Canvas.prototype.customiseControls({
            bl: {
              action: "remove",
              cursor: "pointer"
            },
            br: {
              cursor: "resize",
              action: "scale"
            },
            tl: {
              cursor: "resize",
              action: "scale"
            }
          });
        });

        if (setActive) {
          // Render in canvas in propper layer order position
          let c = 0;
          canvasTemplate.canvas.forEachObject(x => {
            if (
              x.myType != "text" &&
              x.myType != "freeDrawing"
            )
              c++;
          });

          resolve(
            canvasTemplate.canvas
              .insertAt(img1, c <= 0 ? 0 : c - 1)
              .requestRenderAll()
          );
        } else {
          resolve(canvasTemplate.canvas.add(img1).requestRenderAll());
        }

        console.log("==> TEMPLATE STICKER ADDED.");
      },
      { crossOrigin: "*" }
    );
  });
}

function addSticker(item, currentItem, canvasTemplate, mode, myBreakpoint, setActive, canvasMF) {
  // eslint-disable-next-line
  return new Promise((resolve, reject) => {
    fabric.Image.fromURL(
      item.image,
      function (img) {
        let img1 = img.set({
          id: item.id,
          image: item.image,
          myType: "sticker",
          allowDelete: item.allowDelete,
          allowManipulate: item.allowManipulate,
          allowReplace: item.allowReplace,
          left: item.left ? item.left * canvasMF : (currentItem.width / 2) * canvasMF,
          top: item.top ? item.top * canvasMF : (currentItem.height / 2) * canvasMF,
          angle: item.angle ? item.angle : 0,
          scaleX: item.scaleX ? item.scaleX * canvasMF : 1 * canvasMF,
          scaleY: item.scaleX ? item.scaleX * canvasMF : 1 * canvasMF,
          originX: "center",
          originY: "center",
          selectable: (("allowDelete" in item && item.allowDelete) || ("allowManipulate" in item && item.allowManipulate) || ("allowReplace" in item && item.allowReplace != "")) || mode ? true : false,
          evented: (("allowDelete" in item && item.allowDelete) || ("allowManipulate" in item && item.allowManipulate) || ("allowReplace" in item && item.allowReplace != "")) || mode ? true : false,
          lockMovementX: "allowManipulate" in item && item.allowManipulate || mode ? false : true,
          lockMovementY: "allowManipulate" in item && item.allowManipulate || mode ? false : true,
          centeredScaling: true,
          borderColor: "rgba(255,0,0,0.5)",
          cornerStrokeColor: "rgba(0,0,0,0)",
          borderScaleFactor: currentItem.width / 150 * canvasMF,
          rotatingPointOffset: currentItem.width / 20 * canvasMF,
          cornerSize: myBreakpoint.smAndUp
            ? currentItem.width / 25 * canvasMF
            : currentItem.width / 12 * canvasMF,
          cornerShape: "rect",
          transparentCorners: true
        });

        // zmanjšamo velikost prevelikim nalepkam
        let dW = ((currentItem.width * canvasMF - img1.getScaledWidth()) * 100) / currentItem.width;
        let dH = ((currentItem.height * canvasMF - img1.getScaledHeight()) * 100) / currentItem.height;
        let aRatio = img1.getScaledWidth() / img1.getScaledHeight();
        let tW = currentItem.width * canvasMF * 0.7;
        let tH = currentItem.height * canvasMF * 0.7;

        if (dW < 0 || dH < 0) {
          if (dW < dH) {
            img1.scaleToHeight(tW * aRatio);
            img1.scaleToWidth(tW);
          } else {
            img1.scaleToWidth(tH * aRatio);
            img1.scaleToHeight(tH);
          }
        }

        console.log(dW, dH, tW, tH);
        // poskrbimo za pomanjšanje slike, če je prevelika
        let wWidth = 1;
        let wHeight = 1;
        let wReal = 1;
        let wFactor = 1;

        if (
          img1.width >
          currentItem.width ||
          img1.height >
          currentItem.height
        ) {
          wWidth =
            (img1.width * 100) /
            currentItem.width;
          wHeight =
            (img1.height * 100) /
            currentItem.height;

          wReal = wWidth >= wHeight ? wWidth : wHeight;

          if (wReal > 90 && wReal < 180) {
            wFactor = 0.5;
          } else if (wReal >= 180 && wReal < 270) {
            wFactor = 0.37;
          } else if (wReal >= 270 && wReal < 390) {
            wFactor = 0.25;
          } else if (wReal >= 390) {
            wFactor = 0.13;
          }

          console.log(wWidth, wHeight, wReal, wFactor);
          console.log(currentItem.width, currentItem.height, img1.width, img1.height);
        }

        //img1.scaleX = currentItem.width * canvasMF * Math.abs(wFactor);
        //img1.scaleY = currentItem.height * canvasMF * Math.abs(wFactor);

        img1.setControlsVisibility({
          tl: "allowManipulate" in item && item.allowManipulate || mode ? true : false,
          tr: "allowManipulate" in item && item.allowManipulate || mode ? true : false,
          bl: "allowManipulate" in item && item.allowManipulate || "allowDelete" in item && item.allowDelete || mode ? true : false,
          br: "allowManipulate" in item && item.allowManipulate || "allowReplace" in item && item.allowReplace || mode ? true : false,
          ml: "allowManipulate" in item && item.allowManipulate || mode ? true : false,
          mt: false,
          mr: "allowManipulate" in item && item.allowManipulate || mode ? true : false,
          mb: false,
          mtr: "allowManipulate" in item && item.allowManipulate || mode ? true : false,
        });

        img1.customiseCornerIcons({
          tl: {
            icon: require("@/assets/resize-icon-tl.svg")
          },
          tr: {
            icon: require("@/assets/resize-icon-tr.svg")
          },
          bl: {
            icon: ("allowDelete" in item && item.allowDelete) || mode ? require("@/assets/delete-icon.svg") : require("@/assets/resize-icon-bl.svg")
          },
          br: {
            icon: ("allowReplace" in item && item.allowReplace) ? require("@/assets/icon-plus.svg") : require("@/assets/resize-icon-br.svg")
          },
          ml: {
            icon: require("@/assets/down-arrow.svg")
          },
          mr: {
            icon: require("@/assets/up-arrow.svg")
          },
          mtr: {
            icon: require("@/assets/rotate-icon.svg")
          }
        });

        img1.on("selected", function () {
          fabric.Canvas.prototype.customiseControls({
            bl: {
              action: ("allowDelete" in item && item.allowDelete) || mode ? "remove" : "scale",
              cursor: ("allowDelete" in item && item.allowDelete) || mode ? "pointer" : "resize"
            },
            br: {
              cursor: ("allowReplace" in item && item.allowReplace) ? "pointer" : "resize",
              action: ("allowReplace" in item && item.allowReplace) ? function () {
                canvasTemplate.canvas.showStickerControls = true;
                canvasTemplate.canvas.allowReplace = item.allowReplace;
                console.log("FIRE STICKERS");
              } : "scale",
            },
            ml: {
              cursor: "pointer",
              action: function (e, target) {
                target.sendBackwards(true);
              },
            },
            mr: {
              cursor: "pointer",
              action: function (e, target) {
                target.bringForward(true);
              },
            },
            tl: {
              cursor: "resize",
              action: "scale"
            }
          });
        });

        if (setActive) {
          // Render in canvas in propper layer order position
          let c = 0;
          let found = false;
          canvasTemplate.canvas.forEachObject(x => {
            //console.log(x.myType, c);
            if (
              x.myType != "text" &&
              x.myType != "freeDrawing"
            ) {
              c++;
            } else found = true;
          });

          if (found) {
            resolve(
              canvasTemplate.canvas
                .insertAt(img1, c)
                .requestRenderAll()
            );
          } else
            resolve(
              canvasTemplate.canvas
                .add(img1)
                .requestRenderAll()
            )

          /*canvasTemplate.canvas.forEachObject(x => {
            console.log(x.myType);
          });*/
        } else {
          resolve(canvasTemplate.canvas.add(img1).requestRenderAll());
        }

        console.log("==> STICKER ADDED.");
      },
      { crossOrigin: "*" }
    );
  });
}

function addStickerFromFile(item, currentItem, canvasTemplate, mode, myBreakpoint, setActive, canvasMF) {
  // eslint-disable-next-line
  return new Promise((resolve, reject) => {
    fabric.Image.fromURL(
      item.image,
      function (img) {
        let img1 = img.set({
          id: uuidv4(),
          image: item.image,
          myType: "sticker",
          allowDelete: true,
          allowManipulate: true,
          allowReplace: true,
          left: item.left ? item.left * canvasMF : (canvasTemplate.selected.width / 2) * canvasMF,
          top: item.top ? item.top * canvasMF : (canvasTemplate.selected.height / 2) * canvasMF,
          angle: item.angle ? item.angle : 0,
          scaleX: item.scaleX ? item.scaleX * canvasMF : 1 * canvasMF,
          scaleY: item.scaleX ? item.scaleX * canvasMF : 1 * canvasMF,
          originX: "center",
          originY: "center",
          selectable: (("allowDelete" in item && item.allowDelete) || ("allowManipulate" in item && item.allowManipulate) || ("allowReplace" in item && item.allowReplace != "")) || mode ? true : false,
          evented: (("allowDelete" in item && item.allowDelete) || ("allowManipulate" in item && item.allowManipulate) || ("allowReplace" in item && item.allowReplace != "")) || mode ? true : false,
          lockMovementX: "allowManipulate" in item && item.allowManipulate || mode ? false : true,
          lockMovementY: "allowManipulate" in item && item.allowManipulate || mode ? false : true,
          centeredScaling: true,
          borderColor: "rgba(255,0,0,0.5)",
          cornerStrokeColor: "rgba(0,0,0,0)",
          borderScaleFactor: canvasTemplate.selected.width / 150 * canvasMF,
          rotatingPointOffset: canvasTemplate.selected.width / 20 * canvasMF,
          cornerSize: myBreakpoint.smAndUp
            ? canvasTemplate.selected.width / 25 * canvasMF
            : canvasTemplate.selected.width / 12 * canvasMF,
          cornerShape: "rect",
          transparentCorners: true
        });

        // zmanjšamo velikost prevelikim nalepkam
        let dW = ((canvasTemplate.selected.width * canvasMF - img1.getScaledWidth()) * 100) / canvasTemplate.selected.width;
        let dH = ((canvasTemplate.selected.height * canvasMF - img1.getScaledHeight()) * 100) / canvasTemplate.selected.height;
        let aRatio = img1.getScaledWidth() / img1.getScaledHeight();
        let tW = canvasTemplate.selected.width * canvasMF * 0.7;
        let tH = canvasTemplate.selected.height * canvasMF * 0.7;

        if (dW < 0 || dH < 0) {
          if (dW < dH) {
            img1.scaleToWidth(tW);
            img1.scaleToHeight(tW * aRatio);
          } else {
            img1.scaleToWidth(tH);
            img1.scaleToHeight(tH * aRatio);
          }
        }

        img1.setControlsVisibility({
          tl: "allowManipulate" in item && item.allowManipulate || mode ? true : false,
          tr: "allowManipulate" in item && item.allowManipulate || mode ? true : false,
          bl: "allowManipulate" in item && item.allowManipulate || "allowDelete" in item && item.allowDelete || mode ? true : false,
          br: "allowManipulate" in item && item.allowManipulate || "allowReplace" in item && item.allowReplace || mode ? true : false,
          ml: "allowManipulate" in item && item.allowManipulate || mode ? true : false,
          mt: false,
          mr: "allowManipulate" in item && item.allowManipulate || mode ? true : false,
          mb: false,
          mtr: "allowManipulate" in item && item.allowManipulate || mode ? true : false,
        });

        img1.customiseCornerIcons({
          tl: {
            icon: require("@/assets/resize-icon-tl.svg")
          },
          tr: {
            icon: require("@/assets/resize-icon-tr.svg")
          },
          bl: {
            icon: ("allowDelete" in item && item.allowDelete) || mode ? require("@/assets/delete-icon.svg") : require("@/assets/resize-icon-bl.svg")
          },
          br: {
            icon: ("allowReplace" in item && item.allowReplace) ? require("@/assets/icon-plus.svg") : require("@/assets/resize-icon-br.svg")
          },
          ml: {
            icon: require("@/assets/down-arrow.svg")
          },
          mr: {
            icon: require("@/assets/up-arrow.svg")
          },
          mtr: {
            icon: require("@/assets/rotate-icon.svg")
          }
        });

        img1.on("selected", function () {
          fabric.Canvas.prototype.customiseControls({
            bl: {
              action: ("allowDelete" in item && item.allowDelete) || mode ? "remove" : "scale",
              cursor: ("allowDelete" in item && item.allowDelete) || mode ? "pointer" : "resize"
            },
            br: {
              cursor: ("allowReplace" in item && item.allowReplace) ? "pointer" : "resize",
              action: ("allowReplace" in item && item.allowReplace) ? function () {
                canvasTemplate.canvas.showStickerControls = true;
                canvasTemplate.canvas.allowReplace = item.allowReplace;
                console.log("FIRE STICKERS FROM FILE");
              } : "scale",
            },
            ml: {
              cursor: "pointer",
              action: function (e, target) {
                target.sendBackwards(true);
              },
            },
            mr: {
              cursor: "pointer",
              action: function (e, target) {
                target.bringForward(true);
              },
            },
            tl: {
              cursor: "resize",
              action: "scale"
            }
          });
        });

        if (setActive) {
          // Render in canvas in propper layer order position
          let c = 0;
          let found = false;
          canvasTemplate.canvas.forEachObject(x => {
            //console.log(x.myType, c);
            if (
              x.myType != "text" &&
              x.myType != "freeDrawing"
            ) {
              c++;
            } else found = true;
          });

          if (found) {
            resolve(
              canvasTemplate.canvas
                .insertAt(img1, c)
                .requestRenderAll()
            );
          } else
            resolve(
              canvasTemplate.canvas
                .add(img1)
                .requestRenderAll()
            )
        } else {
          resolve(canvasTemplate.canvas.add(img1).requestRenderAll());
        }

        console.log("==> STICKER FROM FILE ADDED.");
      },
      { crossOrigin: "*" }
    );
  });
}

export {
  changeBackgroundImageFilter,
  changeBackgroundImageBlur,
  changeBackgroundImageBrightness,
  changeBackgroundImageContrast,
  addTemplateSticker,
  addSticker,
  addStickerFromFile,
  addTemplateFrame,
  addFrame,
  addText,
  addTemplateText
};